<template>
  <AuthLayout>
    <div class="sign-up">
      <div class="sign-up__header">
        <div class="sign-up__header__title">Create your account</div>
        <div class="sign-up__header__description">
          <a class="sign-up__header__description__link" href="https://www.protosterminal.com/dashboard"> https://www.protosterminal.com/dashboard </a>
        </div>
      </div>
      <form @submit.prevent class="sign-up__form">
        <div class="sign-up__form__flex">
          <BaseInput v-model="form.name" label="First name" required />
          <BaseInput v-model="form.family_name" label="Last name" required />
        </div>
        <div class="sign-up__form__fullwidth">
          <BaseInput v-model="form.username" label="Email" required />
        </div>
        <div class="sign-up__form__fullwidth">
          <BaseInput v-model="form.password" type="password" label="Password" required />
          <div v-if="!isValidPassword" class="sign-up__form__fullwidth__password-comment">
            Password must be 8-32 characters and include at least one letter and one number.
          </div>
        </div>
        <div class="sign-up__form__fullwidth">
          <BaseCheckbox
              v-model="policyAgreement"
              label="I have read and agree to <a href=#>Protos's Terms and Privacy Policy</a>"
              @click-label="showTermsAndPrivacyModal = true"
          />
        </div>
        <div class="sign-up__form__fullwidth">
          <BaseButton :disabled="!policyAgreement" type="submit" label="Sign up" @click="signupHandler" />
        </div>
      </form>
      <div class="sign-up__redirect">
        <div class="sign-up__redirect__label">Already have an account?
          <router-link class="sign-up__redirect__link" to="/sign-in">Log in here</router-link>
        </div>
      </div>
    </div>
    <TermsAndPrivacy v-if="showTermsAndPrivacyModal" @close="showTermsAndPrivacyModal = false" />
  </AuthLayout>
</template>

<script>
import { mapActions } from "vuex";
import { isValidPassword } from "@/helpers/rules";
import { createUser } from "@/services/auth";
import AuthLayout from '@/layouts/AuthLayout.vue'
import BaseInput from "@/components/ui/atoms/BaseInput";
import BaseCheckbox from "@/components/ui/atoms/BaseCheckbox";
import BaseButton from "@/components/ui/atoms/BaseButton";
import TermsAndPrivacy from "@/components/ui/shared/modals/termes-and-privacy/TermsAndPrivacy";

export default {
  name: "SignupView",
  components: { BaseButton, BaseCheckbox, BaseInput, TermsAndPrivacy, AuthLayout },
  data() {
    return {
      form: {
        name: '',
        family_name: '',
        username: '',
        password: '',
      },
      policyAgreement: false,
      showTermsAndPrivacyModal: false
    }
  },
  computed: {
    isValidPassword() {
      return isValidPassword(this.form.password)
    }
  },
  methods: {
    ...mapActions({
      setIsLoading: 'setIsLoading',
      setSnackbarError: 'setSnackbarError'
    }),
    signupHandler() {
      this.setIsLoading(true)
      createUser(this.form)
          .then(() => this.$router.push('/'))
          .catch(({ message }) => this.setSnackbarError(message))
          .finally(() => this.setIsLoading(false))
    }
  }
}
</script>

<style lang="scss" scoped>
// shared design
  .sign-up {
    max-width: 620px;

    &__header {

      &__title {
        font-weight: 700 ;
        font-size: 2rem;
        padding: 1rem 0;
        text-align: start;
      }

      &__description {
        display: flex;
        gap: 10px;
        padding-bottom: 2.5rem;

        &__img {
          stroke: #4f7775;
          color: #4f7775;
          height: 1rem;
          width: 1rem;
        }

        &__link {
          color: #4f7775;
          size: 1rem;
        }

      }

    }

    &__form {

      &__flex {
        display: flex;
        gap: 2rem;

        div {
          flex: 1;
        }
      }

      &__fullwidth {
        margin-top: 2rem;

        &__password-comment {
          margin-top: 0.5rem;
          font-size: 0.85rem;
          font-weight: 600;
        }
      }

    }

    &__redirect {
      text-align: center;
      padding-top: 2rem;

      &__link {
        font-size: 1rem;
        font-weight: 700;
        color: blueviolet;
        padding: 0.5rem 0.125rem;
      }
    }
  }

  // mobile only
  @media (max-width: 786px) {
    .sign-up {

      &__form {

        &__flex {
          flex-direction: column;
        }

      }
    }
  }
</style>
